import React, { useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';

function Challenge({ onLogin }) {
  const [passphrase, setPassphrase] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const response = await axios.post(
        '/api/verify-challenge',
        { challenge: passphrase },
        { withCredentials: true }
      );
      console.log('Verify response:', response.data);
      if (response.data.success) {
        setMessage('Access granted!');
        const token = response.data.token;
        localStorage.setItem('budget_auth', token);
        localStorage.setItem('budget_user', response.data.user);
        Cookies.set('budget_auth', token, { 
          expires: 365, 
          secure: true, 
          sameSite: 'Lax',  // Changed from Strict to Lax for cross-domain
          path: '/' // Ensure cookie is available across the whole site
        });
        onLogin(response.data.user);
      } else {
        setMessage('Incorrect passphrase. Try again.');
      }
    } catch (err) {
      setMessage(err.response?.data?.error || `Error: ${err.message}`);
      console.error('Submit error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen p-6 flex justify-center items-center relative overflow-hidden">
      {/* Floating glass orbs for ambiance */}
      <div className="absolute top-1/4 left-1/4 w-32 h-32 glass rounded-full animate-float opacity-30"></div>
      <div className="absolute bottom-1/3 right-1/4 w-24 h-24 glass rounded-full animate-float opacity-20" style={{animationDelay: '2s'}}></div>
      <div className="absolute top-1/2 right-1/3 w-16 h-16 glass rounded-full animate-float opacity-25" style={{animationDelay: '4s'}}></div>
      
      <div className="glass glass-hover rounded-2xl p-8 w-full max-w-md animate-slideInLeft">
        <div className="text-center mb-8">
          <div className="w-16 h-16 glass rounded-full mx-auto mb-4 flex items-center justify-center">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">Budget App</h1>
          <p className="text-white/80 text-sm">Enter your secret passphrase to unlock</p>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="relative">
            <input
              type="password"
              value={passphrase}
              onChange={(e) => setPassphrase(e.target.value)}
              placeholder="Secret passphrase"
              className="glass-input w-full p-4 rounded-xl text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-white/30 transition-all duration-300"
              disabled={loading}
            />
            <div className="absolute inset-0 rounded-xl ring-1 ring-white/20 pointer-events-none"></div>
          </div>
          
          <button
            type="submit"
            disabled={loading}
            className="glass-button w-full p-4 rounded-xl text-white font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <span className="flex items-center justify-center space-x-2">
              {loading && (
                <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              )}
              <span>{loading ? 'Verifying...' : 'Unlock'}</span>
            </span>
          </button>
        </form>
        
        {message && (
          <div className={`mt-6 p-3 rounded-xl text-center text-sm font-medium ${
            message.includes('granted') 
              ? 'glass text-green-200 border-green-400/30' 
              : 'glass text-red-200 border-red-400/30'
          }`}>
            {message}
          </div>
        )}
      </div>
    </div>
  );
}

export default Challenge;